"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementToggle = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useElementToggle = function useElementToggle(toggleElementRef, windowCallback, elementCallback) {
  return _react.default.useEffect(function () {
    var _toggleElementRef$cur;
    // attach listener to close menu on clicking outside element
    window.addEventListener('click', function (e) {
      windowCallback(e);
    });
    toggleElementRef === null || toggleElementRef === void 0 ? void 0 : (_toggleElementRef$cur = toggleElementRef.current) === null || _toggleElementRef$cur === void 0 ? void 0 : _toggleElementRef$cur.addEventListener('click', function (e) {
      elementCallback(e);
    });

    // cleanup
    return function () {
      var _toggleElementRef$cur2;
      window.removeEventListener('click', function (e) {
        windowCallback(e);
      });
      toggleElementRef === null || toggleElementRef === void 0 ? void 0 : (_toggleElementRef$cur2 = toggleElementRef.current) === null || _toggleElementRef$cur2 === void 0 ? void 0 : _toggleElementRef$cur2.removeEventListener('click', function (e) {
        elementCallback(e);
      });
    };
  }, []);
};
exports.useElementToggle = useElementToggle;